/** * @author FightFastest * @date 29/12/2021 下午 3:21 */
<script>
export default {
	name: 'temp',
	data() {
		return {
			resTable:[]
		}
	},
	props: {
		info: {
			type: Array,
			default: () => []
		}
	},
	mounted() {
		let resTable = {}
		this.info.forEach(res => {
			if (JSON.stringify(res) !== '{}') {
				res.sqaList.forEach(resp => {
					if (JSON.stringify(resp) !== '{}') {
						if (!resTable[resp.subCode]) resTable[resp.subCode] = {}
						resTable[resp.subCode]['examSubjectName'] = resp.examSubjectName
						resTable[resp.subCode][`${res.examId}contributionRate`] = resp.contributionRate
					}
				})
			}
		})
		this.resTable = Object.values(resTable)
	},
	render(createElement) {
		return createElement(
			'el-table',
			{
				props: {
					data:this.resTable,
					border: true
				}
			},
			[
				createElement('el-table-column', {
					props: {
						prop: 'examSubjectName',
						label: '学科',
						align: 'center',
						width: '180'
					}
				}),
				...this.getSubList(createElement)
			]
		)
	},
	methods: {
		getSubList(createElement) {
			let resEle = []
			this.info.forEach(res => {
				resEle.push(
					createElement('el-table-column', {
						props: {
							prop: `${res.examId}contributionRate`,
							label: res.examName,
							align: 'center'
						}
					})
				)
			})
			return resEle
		}
	}
}
</script>

<style scoped lang="less"></style>
